import SpriteAnimation from "../sprite/SpriteAnimation";
import GameTime from "../time/GameTime";

export default class Thruster {
    /**
     * 
     * @param {SpriteAnimation} animation 
     * @param {GameTime} gameTime
     */
    constructor(animation, gameTime) {
        /**
         * @constant
         * @type {SpriteAnimation}
         */
        this.animation = animation;

        /**
         * @constant
         * @type {GameTime}
         */
        this.gameTime = gameTime;

        /**
         * @type {boolean}
         */
        this.active = false;

        /**
         * @type {number}
         */
        this.activeTurn = -1;

        /**
         * @type {number}
         */
        this.animationStartTime = 0;
    }

    /**
     * @param {boolean} active 
     */
    setActive(active) {
        if (active && !this.active) {
            this.animationStartTime = Date.now();                
        }

        if (active) {
            // If active, keep track of the turn.  We do not want to turn off the thruster mid-turn.
            this.activeTurn = this.gameTime.turnNumber;
        }

        this.active = active;
    }

    deactivateNow() {
        this.active = false;
        this.activeTurn = -1;
    }

    /**
     * The thruster lasts for a full turn at a minimum.
     * @returns {boolean}
     */
    isActive() {
        return this.active || this.activeTurn >= this.gameTime.turnNumber - 1;
    }

    /**
     * @returns {Sprite}
     */
    getOverlaySprite() {
        if (this.isActive()) {
            return this.animation.getSpriteAsOf(Date.now(), this.animationStartTime);
        }

        return null;
    }
}